import { IResponse } from "models";

export enum ActionType {
  GET_CONSULTATION_LIST = "action/GET_CONSULTATION_LIST",
  GET_CONSULTATION_LIST_SUCCESS = "action/GET_CONSULTATION_LIST_SUCCESS",
  GET_CONSULTATION_LIST_ERROR = "action/GET_CONSULTATION_LIST_ERROR",
}

export interface Action<T> {
  type: ActionType;
  payload: T;
}

export interface IGetConsultationListResponse extends IResponse {
  result: any;
  total_record: number;
}

export interface IConsultationListPayload {
  per_page: number;
  page: number;
}
